export enum AppDatatableCellTypes {
    TEXT = "text",
    DATE = "date",
    MONEY = "money",
    READONLY_TEXT = "ro_text",
    READONLY_MONEY = "ro_money",
    READONLY_HHMM = "ro_hhmm",
    READONLY_MMDDYY = "ro_mmddyy"
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/enums/cell-type.enum.ts